import { render, staticRenderFns } from "./guide.vue?vue&type=template&id=04efe63a&scoped=true"
import script from "./guide.vue?vue&type=script&lang=js"
export * from "./guide.vue?vue&type=script&lang=js"
import style0 from "./guide.vue?vue&type=style&index=0&id=04efe63a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04efe63a",
  null
  
)

export default component.exports